// Registrazione Service Worker con rilevamento aggiornamenti.
// Quando una nuova versione viene installata, emette un CustomEvent 'sw-update-available'
// sul window — il banner UpdateBanner lo ascolta e mostra la notifica.

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');

      // Controlla aggiornamenti subito e ogni 60 secondi finché la tab è aperta
      registration.update().catch(() => {});
      setInterval(() => registration.update().catch(() => {}), 60 * 1000);

      // Quando il browser trova un nuovo SW in installazione
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // C'era gia un SW attivo → questo e un vero aggiornamento
            window.dispatchEvent(new CustomEvent('sw-update-available'));
          }
        });
      });

      // Quando il nuovo SW prende il controllo (dopo skipWaiting), emette comunque l'evento
      let refreshed = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshed) return;
        refreshed = true;
        window.dispatchEvent(new CustomEvent('sw-update-available'));
      });
    } catch (err) {
      console.warn('[SW] Registrazione fallita:', err);
    }
  });
}
